import {
    FETCH_CREATE_ACTIVITY_DATA_SUCCESS,
    FETCH_SKILLSET_TAGS_SUCCESS,
    FETCH_PROPERTY_LOCATION_SUCCESS,
    REMOVE_PROPERTY_LOCATION,
    FETCH_PROPERTY_STATES_SUCCESS,
    FETCH_ASSIGNMENTMETHOD_B2BLIST_SUCCESS,
    FETCH_ASSIGNMENTMETHOD_CONTRACTLIST_SUCCESS,
    FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST_SUCCESS,
    REMOVE_ASSIGNMENT_METHOD_LIST,
    ON_CLOSE_ACTIVITY
    
} from "../actions/actionConstants";

const initialState = {
    model: {},
    skillsetTags: [],
    suggestion: [],
    nonSysReqField: [],
    propertyStates: [],
    assignmentMethodList:[],
    timeZoneData:[]
};

function modelMapping(data) {
    let templateData = [];
    Object.keys(data.TemplateIdNames).map(key => {
        templateData = templateData.concat({ value: key, label: data.TemplateIdNames[key] })
    })
    return Object.assign({}, data, { TemplateIdNames: templateData });
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_CREATE_ACTIVITY_DATA_SUCCESS:
            let requiredField = [];
            action.payload.CustomFields.map(item => {
                if (item.isSystemField == false && item.IsRequired) {
                    requiredField.push({ fieldReq: item.Name, name: item.Label, group: item.Group });
                }
                else if (item.isSystemField == false && item.FieldType == "decimal") {
                    requiredField.push({ fieldReq: item.Name, name: item.Label, group: item.Group });
                }
            })
            return Object.assign(
                {},
                state,
                {
                    model: action.payload.TemplateIdNames ? modelMapping(action.payload) : action.payload,
                    nonSysReqField: requiredField,
                    timeZoneData:action.payload.TimezoneData,
                    assignmentMethodList:action.payload.TeamMembers
                }
            );
        case FETCH_SKILLSET_TAGS_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    skillsetTags: action.payload.tags
                }
            );

        case FETCH_PROPERTY_LOCATION_SUCCESS:
            return Object.assign({}, state, { suggestion: action.payload });

        case FETCH_PROPERTY_STATES_SUCCESS:
            return Object.assign({}, state, { propertyStates: action.payload });

        case REMOVE_PROPERTY_LOCATION:
            return Object.assign({}, state, { suggestion: [] });

        case FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST_SUCCESS:
        case FETCH_ASSIGNMENTMETHOD_B2BLIST_SUCCESS:
        case FETCH_ASSIGNMENTMETHOD_CONTRACTLIST_SUCCESS:
            return Object.assign({}, state, { assignmentMethodList: action.payload });
        case ON_CLOSE_ACTIVITY:
            return Object.assign({}, initialState);
        case REMOVE_ASSIGNMENT_METHOD_LIST:
            return Object.assign({}, state, { assignmentMethodList: [] });
        default:
            return state;
    }
}
